// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2vAfj","infected":"Cards_infected__1OUMA","recovered":"Cards_recovered__2c3xO","deaths":"Cards_deaths__3II7m"};